/* eslint-disable security/detect-object-injection */
/* eslint-disable import/no-unresolved */
import { Button } from "@mui/material";
import { memo, useCallback, useState } from "react";
import { UseMutateFunction } from "react-query";
import { partners } from "src/config/constant";
import { LOAN_STATUS, PROPOSAL_STATUS } from "src/helpers/Dashboard/resources";
import { SET_TOAST_ERROR } from "src/redux/Actions/common";
import store from "src/redux/store";
import { useAppSelector } from "src/utils/hooks/useAppSelector";

interface Props {
  handleVerifyByOtp: () => void;
  callGenerateMef: UseMutateFunction<any, unknown, any, unknown>;
  verifyButtonState: boolean;
}

function CustomerDeclaration({ handleVerifyByOtp, callGenerateMef, verifyButtonState }: Props) {
  const proposalStatus = useAppSelector((state) => state.common.leadDetails?.proposalStatus);
  const leadId = useAppSelector((state) => state.common.leadId);
  const loanStatus = useAppSelector((state) => state.loanStatus.loanStatus);
  const [downloadButtonState, setDownloadButtonState] = useState(false);
  const partnerId = useAppSelector((state) => state.common.leadDetails?.partnerId);

  const handleVerifyByOTPClick = useCallback(() => {
    if (proposalStatus === PROPOSAL_STATUS.MEF_SUBMITTED) {
      store.dispatch(
        SET_TOAST_ERROR({
          error: true,
          message: "MEF already submitted",
          duration: 4000
        })
      );
    } else if (
      loanStatus === LOAN_STATUS.SANCTIONED ||
      loanStatus === LOAN_STATUS.DISBURSED ||
      loanStatus === LOAN_STATUS.PENDING
    ) {
      handleVerifyByOtp();
      setDownloadButtonState(true);
    } else {
      store.dispatch(
        SET_TOAST_ERROR({
          error: true,
          message: "Loan is not Sanctioned",
          duration: 4000
        })
      );
    }
  }, [proposalStatus, loanStatus, leadId]);

  const handleDownloadAndVerify = useCallback(() => {
    if (proposalStatus === PROPOSAL_STATUS.MEF_SUBMITTED) {
      store.dispatch(
        SET_TOAST_ERROR({
          error: true,
          message: "MEF already submitted",
          duration: 4000
        })
      );
    } else if (
      loanStatus === LOAN_STATUS.SANCTIONED ||
      loanStatus === LOAN_STATUS.DISBURSED ||
      loanStatus === LOAN_STATUS.PENDING
    ) {
      callGenerateMef({ leadId });
    } else {
      store.dispatch(
        SET_TOAST_ERROR({
          error: true,
          message: "Loan is not Sanctioned",
          duration: 4000
        })
      );
    }
  }, [leadId, proposalStatus, loanStatus]);

  return (
    <div className="mt-10 pb-10 flex justify-center">
      <Button
        disabled={downloadButtonState}
        variant="outlined"
        classes={{ outlined: "!rounded-lg" }}
        onClick={handleDownloadAndVerify}
        className="!text-black !uppercase h-14 rounded-lg !mr-10 !text-sm"
      >
        DOWNLOAD AND VERIFY
      </Button>
      <Button
        disabled={verifyButtonState || [partners.JIO]?.includes(partnerId)}
        variant="contained"
        classes={{ contained: "!rounded-lg" }}
        onClick={handleVerifyByOTPClick}
        className="!uppercase h-14 rounded-lg !text-sm"
      >
        VERIFY BY OTP
      </Button>
    </div>
  );
}

export default memo(CustomerDeclaration);
